import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toolbar as SparkToolbar } from '@sabre/aven-spark';

export default class Toolbar extends Component {
    static propTypes = {
        /** <ToolbarItem /> components to be rendered as child nodes */
        children: PropTypes.node,
        /** Any extra CSS class name(s) added to the root element */
        className: PropTypes.string,
        /** ARIA role attribute */
        role: PropTypes.string,
        /** Custom tabindex attribute */
        tabIndex: PropTypes.string
    };

    static defaultProps = {
        className: '',
        role: 'menubar',
        tabIndex: '0'
    };

    componentDidMount() {
        this._sparkInstance = new SparkToolbar(this._rootEl);
    }

    componentWillUnmount() {
        //this._sparkInstance && this._sparkInstance.remove()
    }

    render() {
        const { children, className, role, tabIndex } = this.props;

        const rootElProps = {
            className: `spark-toolbar ${className}`,
            role,
            tabIndex: `${typeof tabIndex === 'number' && tabIndex < 0 ? '-1' : tabIndex}`
        };

        return (
            <div ref={node => (this._rootEl = node)} {...rootElProps}>
                <div className="spark-toolbar__container--visible">{children}</div>
                <div className="spark-toolbar__show-more" tabIndex="-1">
                    <i className="spark-icon-menu-ellipsis-vertical" />
                </div>
                <div className="spark-toolbar__container--hidden" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/toolbar/toolbar.js